import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const Wrapper = styled.div`
  text-align: center;
  margin: auto;
  margin-bottom: 32px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 56px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-bottom: 48px;
  }

  h2 {
    margin-bottom: 24px;
    font-size: 1.5rem;
    line-height: 130%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 2.25rem;
      line-height: 130%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin-bottom: 32px;
    }
  }

  p {
    font-size: 16px;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 18px;
    }
  }
`;

export const GridContainer = styled(Container)`
  position: relative;
  margin: 0 auto;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(1, 1fr [column]);

  @media only screen and (min-width: 660px) {
    grid-template-columns: repeat(2, 1fr [column]);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 670px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    grid-template-columns: repeat(4, 1fr [column]);
    max-width: none;
  }
`;

export const CtaWrapper = styled.div`
  text-align: center;
`;
